import { ICycle } from 'models/cycle/cycle.model';
interface Month {
	name: string;
	year: number;
	month: number;
	monthIndex: number;
	nameAbbreviated: string;
	nameAbbreviatedWithYear: string;
	nameAbbreviatedWithYearToUpperCase: string;
}
type FunctionCreateMonthListFromCycle<T> = (months: Month) => T;
const createMonthListFromCycle = <T>(
	cycle: ICycle,
	fn: FunctionCreateMonthListFromCycle<T>
) => {
	const result: T[] = [];
	for (let i = 0; i < cycle.duracao; i++) {
		const date = new Date(cycle.ano, cycle.ciclo + i, 1);
		const nameAbbreviatedWithYear =
			date
				.toLocaleString('default', {
					month: 'short',
				})
				.replace('.', '') +
			'/' +
			date.getFullYear();
		const month: Month = {
			name: date.toLocaleString('default', { month: 'long' }),
			year: date.getFullYear(),
			month: date.getMonth() + 1,
			monthIndex: date.getMonth(),
			nameAbbreviated: date.toLocaleString('default', {
				month: 'short',
			}),
			nameAbbreviatedWithYearToUpperCase:
				nameAbbreviatedWithYear.toUpperCase(),
			nameAbbreviatedWithYear: nameAbbreviatedWithYear,
		};
		result.push(fn(month));
	}
	return result;
};
export default createMonthListFromCycle;
